import { Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import PublishIcon from '@mui/icons-material/Publish';
import DeleteIcon from '@mui/icons-material/Delete';
import React from 'react';

interface CellOfferActionsProps {
  params: any;
  onClick: (params: any, clickedElement: 'edit' | 'publish' | 'delete') => void;
  children?: React.ReactNode;
}

const CellOfferActions = ({ params, onClick }: CellOfferActionsProps) => {
  const isPublished = String(params?.row?.status ?? '').toUpperCase() === 'PUBLISHED';
  const isActive = params?.row?.is_active !== false;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 0.5,
      }}
    >
      <Tooltip title="Edit">
        <IconButton
          size="small"
          aria-label="edit"
          onClick={(e) => {
            e.stopPropagation();
            onClick(params, 'edit');
          }}
          sx={{ padding: 0.5 }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      {!isPublished && (
        <Tooltip title={isActive ? 'Publish' : 'Activate offer to publish'}>
          <span>
            <IconButton
              size="small"
              aria-label="publish"
              disabled={!isActive}
              onClick={(e) => {
                e.stopPropagation();
                if (isActive) onClick(params, 'publish');
              }}
              sx={{ padding: 0.5 }}
            >
              <PublishIcon fontSize="small" />
            </IconButton>
          </span>
        </Tooltip>
      )}
      <Tooltip title={isPublished ? 'Published offers cannot be deleted' : 'Delete'}>
        <span>
          <IconButton
            size="small"
            aria-label="delete"
            disabled={isPublished}
            onClick={(e) => {
              e.stopPropagation();
              if (!isPublished) onClick(params, 'delete');
            }}
            sx={{ padding: 0.5 }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  );
};

export default CellOfferActions;
